import * as React from 'react'
import { useTranslation } from 'hooks'
import { iconCrossCircleL, iconTickCircleL } from 'images'
import { formatServerError } from 'helpers'
import * as S from './PasswordCondition.styles'

const PasswordCondition: React.FC<PasswordConditionProps> = ({
  status,
  message
}) => {
  const { t } = useTranslation()

  const getImage = (iconStatus: PasswordConditionStatus) => {
    if (iconStatus === 'error') return iconCrossCircleL
    return iconTickCircleL
  }

  return (
    <S.Container status={status}>
      <S.Icon status={status} iconUrl={getImage(status)} />
      <S.IconLabel className="footnote">
        {formatServerError(t('shared.password'), message)}
      </S.IconLabel>
    </S.Container>
  )
}

export default PasswordCondition

export type PasswordConditionStatus = 'error' | 'satisfied' | 'unsatisfied'

interface PasswordConditionProps {
  status: PasswordConditionStatus
  message: string
}
